import { createContext, useState, useCallback, useMemo } from 'react'

import {
  ThemeProvider as Theme,
  DefaultTheme,
  TColors,
} from 'styled-components'

import { IThemeContext } from './types'

const ThemeContext = createContext({} as IThemeContext)

function ThemeProvider({ children }: any) {
  const [theme, setTheme] = useState<DefaultTheme>({
    colors: {
      primary: '#000000',
      secondary: '#ffffff',
      foreground: '#ffffff',
      light: '#ffffff',
      dark: '#54595e',
      danger: '#ff5c5c',
      warning: '#ffeaa7',
      notice: '#ffe066',
      success: '#2ed573',
      info: '#5c6fff',
      pink: '#ff59bd',
      blue: '#45c1f6',
    },
    fonts: {
      primary: "'Nunito', sans-serif",
      secondary: "'Sarala', sans-serif",
      tertiary: "'Jost', sans-serif",
    },
  })

  const setColors = useCallback((colors: TColors) => {
    setTheme(t => ({ ...t, ...{ colors: { ...t.colors, ...colors } } }))
  }, [])

  const props = useMemo(() => ({ theme, setColors }), [setColors, theme])

  return (
    <ThemeContext.Provider value={props}>
      <Theme theme={theme}>{children}</Theme>
    </ThemeContext.Provider>
  )
}

export { ThemeProvider, ThemeContext }
export * from './styles'
